import { FormControl, IconButton, InputAdornment } from "@mui/material"
import { useContext, useState } from "react"
import { LangContext } from '../../../contexts/LangContext';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputTheme from "../../generic/input"
import React from 'react';

export default function InputPassword({ errorText, ...props }) {
    const { lang } = useContext(LangContext);

    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <FormControl sx={{ width: '100%' }} >
            <InputTheme InputProps={
                {
                    endAdornment:
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                            >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                }
            } error={props.error} type={showPassword ? 'text' : 'password'} helperText={errorText ? "" : errorText} label={lang.components.generic.input_password_label} id="outlined-adornment-password"
                {...props} />
        </FormControl>
    )
}